import { InputMask } from 'primereact/inputmask';
import { ReactComponent as BizLoadingIcon } from 'assets/svg/biz-loading.svg';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';

type ZipCodeProps = {
    zipCode: string;
    setZipCode: Dispatch<SetStateAction<string>>;
    loading: boolean;
    handleBlur: (e: ChangeEvent<HTMLInputElement>) => void;
}

const ZipCodeInput: React.FC<ZipCodeProps> = ({
    zipCode,
    setZipCode,
    loading,
    handleBlur
}:ZipCodeProps): JSX.Element => {
    return (
        <span className={'grid-zip-code-field mb-5'}>
                <div className="p-float-label mb-1">
                    <div className="d-flex position-relative">
                        <InputMask id="zip-code"
                            value={zipCode}
                            onBlur={e => handleBlur(e)}
                            className="w-100"
                            mask="99999-999"
                            name="zipCode"
                            type="tel"
                            onChange={(e) => setZipCode(e.target.value)}
                        />

                        <label htmlFor="zip-code">CEP</label>

                        {loading && (
                            <BizLoadingIcon
                                className="input-img-loading"
                            />
                        )}
                    </div>
                </div>
                <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm"
                    className="pt-2 primary-text" target="_blank">
                    Não sei meu CEP
                </a>
            </span>
    )
}



export default ZipCodeInput;
